export enum ENVIRONMENTS {
  Development = "development", // local
  Staging = "staging", // TEST
  Production = "production",
}
